import React from 'react';
import { useTranslation } from 'react-i18next';

import { RHP } from 'providers';

import * as Styled from './StyledRankingSelect';
import { flags } from './countryflags';

export const RankingCard = props => {
    const { t } = useTranslation('ranking');
    const { countryId } = props;

    const handleClick = () => {
        RHP.push(`/ranking/${countryId.toLowerCase()}/corporate`);
    };

    return (
        <Styled.CardContainer onClick={() => handleClick()}>
            <Styled.Flag src={flags[countryId]} />
            <Styled.RankingText>Ranking {t(`RankingSelect.${countryId}`)}</Styled.RankingText>
            <Styled.CountryBtn type="button">{t(`RankingSelect.join`)}</Styled.CountryBtn>
        </Styled.CardContainer>
    );
};

export default RankingCard;
